<template>
  <div
    @mouseleave="MouseLeave()"
    @mouseover="MouseOver()"
  >
    <v-autocomplete
      v-if="!readonly && !disabled && (hovering || focus) && postcodes.length !== 0"
      v-model="selectedValue"
      :append-icon="ShowControls ? '$dropdown' : ''"
      :clearable="ShowControls"
      :dense="dense"
      :disabled="disabled"
      :items="postcodes"
      :item-text="'tekst'"
      :item-value="'idPostcode'"
      :label="label"
      :readonly="readonly"
      ref="control"
      :reverse="reverse"
      :rules="Rules"
      @blur="focus = false"
      @change="$emit('change', selectedValue)"
      @focus="focus = true"
    />

    <v-text-field
      v-else-if="postcodes.length === 0"
      :dense="dense"
      disabled
      :label="label"
      readonly
      loading
      :reverse="reverse"
      :rules="Rules"
      :value="TextValue"
    />

    <v-text-field
      v-else-if="readonly || disabled || !(hovering || focus) || focusWrong"
      :dense="dense"
      :disabled="disabled"
      :label="label"
      :readonly="readonly"
      :reverse="reverse"
      :rules="Rules"
      :value="TextValue"
      @focus="FocusWrong()"
    />
  </div>
</template>

<script>
import postService from '../services/postService'
import errorMixin from '@/mixins/errorMixin'

export default {
  name: 'ControlPostcode',
  mixins: [
    errorMixin
  ],
  props: {
    dense: Boolean,
    disabled: Boolean,
    label: String,
    readonly: Boolean,
    required: Boolean,
    requiredText: {
      default: 'Required.',
      type: String
    },
    reverse: Boolean,
    value: [Number, Object, String]
  },
  data () {
    return {
      items: [],
      postcodes: [],
      focus: false,
      focusWrong: false,
      hovering: false,
      requiredRule: value => !!value || this.requiredText,
      selectedValue: null
    }
  },
  mounted () {
    postService.Init(this)
    this.GetPosten()
    this.FormatData()
  },
  computed: {
    Rules () {
      if (this.required) {
        return [this.requiredRule]
      } else {
        return []
      }
    },
    ShowControls () {
      return !this.readonly && (this.hovering || this.focus)
    },
    TextValue () {
      const postcode = this.postcodes.find(postcode => postcode.idPostcode === this.selectedValue)
      return postcode == null ? null : postcode.tekst
    }
  },
  watch: {
    selectedValue () {
      this.Emit()
    },
    readonly () {
      if (this.readonly) {
        this.FormatData()
      }
    },
    value () {
      this.FormatData()
    }
  },
  methods: {
    Emit () {
      if (this.selectedValue) {
        this.$emit('input', this.selectedValue)
      } else {
        this.$emit('input', null)
      }
    },
    async GetPosten () {
      const response = await postService.GetPosten()
      if (response && response.data) {
        const data = response.data
        this.postcodes = data
      }
    },
    FocusWrong () {
      this.focusWrong = true
      this.focus = true

      this.$nextTick(() => {
        this.$refs.control.focus()
        this.focusWrong = false
      })
    },
    FormatData () {
      if (this.value) {
        this.selectedValue = this.value
      } else {
        this.selectedValue = null
      }
    },
    MouseLeave () {
      this.hovering = false
      this.$emit('mouseleave')
    },
    MouseOver () {
      this.hovering = true
      this.$emit('mouseover')
    }
  }
}
</script>
